import React, { Component } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import { connect } from 'react-redux';
import SegmentLoader from 'common/components/SegmentLoader';

import {
  getInsectsRef,
  getIsFetching as getIsFetchingInsect,
} from '../reducers/insectsRef';
import { getZone, getIsFetching as getIsFetchingZone } from '../reducers/zone';
import { fetchInsectsRef } from '../actions/insectsRef';
import { Radio, Divider, Form } from 'semantic-ui-react';
import { fetchZone } from '../actions/zone';

const mapStateToProps = state => ({
  isFetching: getIsFetchingZone(state) || getIsFetchingInsect(state),
  insectsRefs: getInsectsRef(state),
  zone: getZone(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchInsectsRef: () => dispatch(fetchInsectsRef()),
  fetchZone: () => dispatch(fetchZone(ownProps.id)),
});

const initializeCaptures = insectsRef => {
  return insectsRef.filter(i => !i.deleted).map(i => ({
    species_id: i.id,
    label: i.label,
    value: 0,
  }));
};

function compare(a, b) {
  if (a.order < b.order) {
    return -1;
  }
  if (a.order > b.order) {
    return 1;
  }
  return 0;
}

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSpeciesThresholdDefault: null,
      speciesThreshold: [],
      otherSpeciesThresholdValue: null,
    };

    this._onIsSpeciesThresholdDefaultChanged = this._onIsSpeciesThresholdDefaultChanged.bind(
      this
    );
    this._onSpeciesCaptureChanged = this._onSpeciesCaptureChanged.bind(this);

    this._onOtherSpeciesThresholdValueChanged = this._onOtherSpeciesThresholdValueChanged.bind(
      this
    );
  }

  componentDidMount() {
    // Loading insects refs
    Promise.all([this.props.fetchInsectsRef(), this.props.fetchZone()]).then(
      response =>
        this.setState(prevState => ({
          isSpeciesThresholdDefault:
            response[1].zone.is_species_threshold_default,
          speciesThreshold: response[1].zone.species_threshold,
          otherSpeciesThresholdValue:
            response[1].zone.other_species_threshold_value,
        }))
    );
  }

  shouldComponentUpdate(nextProps) {
    var compare = shallowCompare(this, nextProps);
    return compare;
  }

  updateSpeciesThreshold(existing, speciesId, value) {
    var index = existing.findIndex(
      obj => obj.species_id === parseInt(speciesId, 0)
    );
    var valueAsNumber = parseInt(value, 0);

    if (index >= 0 && !isNaN(valueAsNumber)) {
      existing[index].value = valueAsNumber;
    }
    return existing;
  }

  _onOtherSpeciesThresholdValueChanged(evt) {
    const { value } = evt.target;

    this.setState(prevState => ({
      otherSpeciesThresholdValue: parseInt(value, 0),
    }));
  }

  _onSpeciesCaptureChanged(evt) {
    const { value, id } = evt.target;

    this.setState((prevState, prevProps) => ({
      speciesThreshold: this.updateSpeciesThreshold(
        prevState.speciesThreshold,
        id,
        value
      ),
    }));
  }

  _onIsSpeciesThresholdDefaultChanged(evt) {
    var speciesThreshold =
      this.props.zone.species_threshold.length === 0
        ? initializeCaptures(this.props.insectsRefs)
        : this.props.zone.species_threshold;

    this.setState((prevState, prevProps) => ({
      isSpeciesThresholdDefault: !prevState.isSpeciesThresholdDefault,
      speciesThreshold: speciesThreshold,
      otherSpeciesThresholdValue: !prevState.isSpeciesThresholdDefault
        ? null
        : 0,
    }));
  }

  render() {
    const { isFetching, insectsRefs } = this.props;

    const {
      isSpeciesThresholdDefault,
      speciesThreshold,
      otherSpeciesThresholdValue,
    } = this.state;

    if (isFetching) {
      return <SegmentLoader />;
    } else {
      const radioLabel = isSpeciesThresholdDefault
        ? 'Paramètres par défaut activé'
        : 'Paramètres par défaut désactivé';

      const enrichedSpeciesThreshold = speciesThreshold
        .map(s => {
          if (s.label) {
            return s;
          } else {
            var speciesRef = insectsRefs.find(r => r.id === s.species_id);
            var indexRef = insectsRefs.findIndex(r => r.id === s.species_id);
            var speciesLabel = speciesRef ? speciesRef.label : '';
            return {
              ...s,
              label: speciesLabel,
              order: indexRef,
            };
          }
        })
        .sort(compare);

      return (
        <div>
          <div className="ui field">
            <label>Légende</label>
            <Radio
              name="is_species_threshold_default"
              value={isSpeciesThresholdDefault ? 'true' : 'false'}
              checked={isSpeciesThresholdDefault}
              onChange={this._onIsSpeciesThresholdDefaultChanged}
              toggle
              label={radioLabel}
            />
          </div>
          {isSpeciesThresholdDefault && (
            <div>
              <Divider />
              <div className="ui field inline">
                <label>
                  Toute espèce : Seuil d'alerte quand capture supérieur à
                </label>
                <input type="hidden" name="species_threshold" />
                <input type="text" value={0} disabled />
              </div>
              <Divider />
            </div>
          )}
          {!isSpeciesThresholdDefault && (
            <div>
              <div>
                <Divider />
                {enrichedSpeciesThreshold.map((i, index) => {
                  var speciesName = `species_threshold[${index}].species_id`;
                  var valueName = `species_threshold[${index}].value`;
                  return (
                    <Form.Group inline>
                      <Form.Field>
                        <label>
                          {i.label} : Seuil d'alerte quand capture supérieur à
                        </label>
                        <input
                          type="hidden"
                          name={speciesName}
                          value={i.species_id}
                        />
                        <input
                          type="text"
                          id={i.species_id}
                          name={valueName}
                          value={i.value}
                          onChange={this._onSpeciesCaptureChanged}
                        />
                      </Form.Field>
                    </Form.Group>
                  );
                })}
                <Form.Group inline>
                  <Form.Field>
                    <label>
                      Autre espèce: Seuil d'alerte quand capture supérieur à
                    </label>
                    <input
                      type="text"
                      id="other_species_threshold_value"
                      name="other_species_threshold_value"
                      value={otherSpeciesThresholdValue || 0}
                      onChange={this._onOtherSpeciesThresholdValueChanged}
                    />
                  </Form.Field>
                </Form.Group>
                <Divider />
              </div>
            </div>
          )}
        </div>
      );
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/informations/components/App.js